import * as React from 'react';
import {Grid, TextField} from '@mui/material';

import { SearchField } from 'views/Dashboard/shared';
import { searchObjects } from 'utils/searchObjects';
import { extractType } from '../utils';

const VideosFilters = (props) => {

    const {
        items,
        onChange
        
    } = props;

    const [search, setSearch] = React.useState("");
    const [videoType, setVideoType] = React.useState("All");
    const typeOptions = ["All","Product","Page"];

    React.useEffect(() => {
        console.log("RENDERING FILTERS");
        onFilterItems();
    },[items, search, videoType]);

  
    const handleSearch = (value) => setSearch(value);
    const handleTypeChange = (event) => setVideoType(event.target.value);

    const filterSearch = (list) => searchObjects(list, search);

    const filterType = (list) => {

        if(videoType == 'All') return list;

        return list.filter(item => extractType(item.videoable_type) == videoType);
    }

    const onFilterItems = () => {
        
        let filteredItems = items;

        filteredItems = filterSearch(filteredItems);
        filteredItems = filterType(filteredItems);
        onChange(filteredItems);

    }

    return (
        <Grid
        container
        spacing={3}
        >
            <Grid
            item
            md={3}
            xs={12}
            >
                <SearchField onChange={handleSearch} />
            </Grid>
            <Grid
                item
                md={4}
                xs={12}
              >
               <TextField
                  fullWidth
                  label="Type"
                  name="videoable_type"
                  onChange={handleTypeChange}
                  value={videoType}
                  select
                  SelectProps={{ native: true }}
                  variant="outlined"
                >
                  {typeOptions.map((option) => (
                    <option
                      key={option}
                      value={option}
                    >
                      {option}
                    </option>
                  ))}
                </TextField>
              </Grid>
              
        </Grid>

    )

}

export default VideosFilters;